import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { ActivityDrawerComponent } from "./activity-drawer/activity-drawer.component";
import { MessengerDrawerComponent } from "./messenger-drawer/messenger-drawer.component";
import { ChatInnerModule } from "../../content/chat-inner/chat-inner.module";
import { SharedModule } from "../../../../../shared/shared.module";
import { CartDrawerComponent } from "./cart-drawer/cart-drawer.component";
import { CartInnerDrawerComponent } from "src/app/pages/courses/component/cart-drawer/cart-inner-drawer.component";

@NgModule({
  declarations: [
    ActivityDrawerComponent,
    MessengerDrawerComponent,
    CartDrawerComponent,
  ],
  imports: [
    CommonModule,
    InlineSVGModule,
    RouterModule,
    ChatInnerModule,
    SharedModule,
    CartInnerDrawerComponent,
  ],
  exports: [
    ActivityDrawerComponent,
    MessengerDrawerComponent,
    CartDrawerComponent,
  ],
})
export class DrawersModule {}
